import Script from 'next/script'

export function Digioh() {
  return (
    <Script
      id="digioh"
      strategy="afterInteractive"
      src="https://www.lightboxcdn.com/vendor/0d1ee324-9c1b-4837-88cd-a5a4a387633a/lightbox_speed.js"
    />
  )
}
